import React, { useState } from "react";
import { Col, Container, Row, Image, Card, Button, Modal, } from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import bnrimg_1 from "../assets/images/bnrimg_1.png";
import hsptl_w from "../assets/images/hsptl_w.png";
import stdnt_w from "../assets/images/stdnt_w.png";
import schl_w from "../assets/images/schl_w.png";
import abtus1 from "../assets/images/abtus1.png";
import abtus2 from "../assets/images/abtus2.png";
import { FaQuoteRight } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import { SetPageTittle } from "../services/utils";
import { useNavigate } from "react-router-dom";
import Testemonials from "../components/common-components/testmonials";
const Homepage = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <div className="hm_respn">
            <Header />
            <section className="banner_section">
                <Swiper
                    spaceBetween={30}
                    slidesPerView={1}
                    loop={true}
                    autoplay={true}
                    // onSlideChange={() => console.log("slide change")}
                    // onSwiper={(swiper) => console.log(swiper)}
                    modules={[Autoplay]}
                    className="bnnr_swiper"
                >
                    <SwiperSlide>
                        <div className="bnnr_slide">
                            <div className="bnnr_img">
                                <Image src={bnrimg_1} fluid />
                            </div>
                            <div className="bnnr_cntnt">
                                <h1>
                                    <span className="hdng_hlt">Schools</span>{" "}
                                    <br />
                                    Streamlined process
                                </h1>
                                <h3>Reduce paperwork!</h3>
                                <p>
                                    Automatic notifications for students on
                                    hospital requirements and ability for them
                                    to be ready for their rotations.
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="bnnr_slide">
                            <div className="bnnr_img">
                                <Image src={bnrimg_1} fluid />
                            </div>
                            <div className="bnnr_cntnt">
                                <h1>
                                    <span className="hdng_hlt">Students</span>{" "}
                                    <br />
                                    Scheduled rotations…
                                </h1>
                                <h3>track onboarding information!</h3>
                                <p>
                                    View your scheduled rotations and download
                                    the needed documentation. Stay in compliance
                                    throughout the rotation period.
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="bnnr_slide">
                            <div className="bnnr_img">
                                <Image src={bnrimg_1} fluid />
                            </div>
                            <div className="bnnr_cntnt">
                                <h1>
                                    <span className="hdng_hlt">Hospitals</span>{" "}
                                    <br />
                                    Cloud based…
                                </h1>
                                <h3>and be ready for audits!</h3>
                                <p>
                                    A single solution addresses
                                    interdisciplinary (Nursing, Allied health,
                                    Medical, Advanced Practice, High school,
                                    Interns) student needs across your hospital
                                    system.
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </section>
            <section className="all_logins container_width_set">
                <Container>
                    <Row>
                        <Col md={4}>
                            <div className="hmlogin_card">
                                <Card className="mb-2">
                                    <Card.Body>
                                        <Card.Img
                                            src={schl_w}
                                            className="img-fluid"
                                        />
                                        <div className="respn_text">
                                            <div className="div_schol">
                                                <Card.Title as="h4">
                                                    School Portal{" "}
                                                </Card.Title>
                                                <Card.Text>
                                                    With supporting text below as a
                                                    natural lead-in to additional
                                                    content.
                                                </Card.Text>
                                            </div>
                                            <Button
                                                variant=""
                                                className="btn_theme btn_theme_w"
                                                onClick={() => { SetPageTittle({ tittle: 'School' }); navigate("/signin") }}
                                            >
                                                Log In
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="hmlogin_card">
                                <Card className="mb-2">
                                    <Card.Body>
                                        <Card.Img
                                            src={stdnt_w}
                                            className="img-fluid"
                                        />
                                         <div className="respn_text">
                                            <div className="div_schol">
                                                <Card.Title as="h4">
                                                    Student Portal{" "}
                                                </Card.Title>
                                                <Card.Text>
                                                    With supporting text below as a
                                                    natural lead-in to additional
                                                    content.
                                                </Card.Text>
                                            </div>
                                            <Button
                                                variant=""
                                                className="btn_theme btn_theme_w"
                                                onClick={() => { SetPageTittle({ tittle: 'Student' }); navigate("/signin") }}
                                            >
                                                Log In
                                            </Button>
                                         </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="hmlogin_card">
                                <Card className="mb-2">
                                    <Card.Body>
                                        <Card.Img
                                            src={hsptl_w}
                                            className="img-fluid"
                                        />
                                        <div className="respn_text">
                                            <div className="div_schol">
                                                <Card.Title as="h4">
                                                    Hospital Portal{" "}
                                                </Card.Title>
                                                <Card.Text>
                                                    With supporting text below as a
                                                    natural lead-in to additional
                                                    content.
                                                </Card.Text>
                                            </div>
                                            <Button
                                                variant=""
                                                className="btn_theme btn_theme_w"
                                                onClick={() => { SetPageTittle({ tittle: 'Hospital' }); navigate("/signin") }}
                                            >
                                                Log In
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="about_us1 container_width_set on_needs_bords">
                <Container>
                    <Row className="align-items-center on_neesd_wrks">
                        <Col md={6}>
                            <div className="about_cntnt">
                                <h2>Servicing All Your Onboarding Needs</h2>
                                <p>
                                    Every day we have the privileged of working with hospitals, universities, and consortiums.
                                     We have never
                                    believed that one software program will fit
                                    the needs of every Hospital or University so
                                    each partnership is unique and each time, we
                                    tailor ClinicalEdify to the needs and
                                    specifications of that Program. After all,
                                    understanding your programs’ needs and
                                    challenges helps to build a better solution.{" "}
                                </p>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="about_img">
                                <Image src={abtus1} fluid />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="about_us1 about_us2 container_width_set">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <div className="about_img">
                                <Image src={abtus2} fluid />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="about_cntnt">
                                <h2>Streamlined Process</h2>
                                <p>
                                    “Organized”, “Efficient”, “Streamlined”…
                                    they are all words we want used to describe
                                    our daily work in the jobs we love. When it
                                    comes to setting up and managing Clinical
                                    Rotations, too often the words we might use
                                    to describe our work are “Repetitious”,
                                    “Time-Consuming” and “Scattered”. In an
                                    effort to relieve the stress of approving,
                                    preparing for, and monitoring Clinical
                                    Rotations, we created a software program
                                    called “ClinicalEdify”.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="clnt_tstmnls">
               <Testemonials />
            </section>
            <Footer />
        
        </div>
    );
};

export default Homepage;
